import React, {useMemo} from 'react';
import {ITaskSingleVoyage} from "@containers/singleVoyage/tasks/types";
import {countCompletedExecutionsSingleVoyage} from "@containers/singleVoyage/tasks/helpers/executions";


interface IProps {
    tasks: ITaskSingleVoyage[]
}

/**
 * Counts executions, not "parent + children": the parent is an aggregate, and
 * counting it as a separate unit inflated the denominator.
 */
const CompleteCountTasksSingleVoyage = ({tasks}: IProps) => {

    const counts = useMemo(() => countCompletedExecutionsSingleVoyage(tasks), [tasks])

    return (
        <>
            {counts.complete} / {counts.total}
        </>
    );
};

export default CompleteCountTasksSingleVoyage;
